<template>
    <div v-if="task.output">
        <div class="tasks-bar-buttons">
            <a :href="task.output.xlsxUrl" v-if="task.output.xlsxUrl" target="_blank" v-tooltip title="Excel 2007 ou superior">
                <i class="fa-file"></i>
                Excel
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ExportReportV1.vue?0a0754f0